import React from "react";
import {LevelBadge} from "views/components/level_badge/level_badge.component";
import {GameLevel} from "data/enums";
import {Exist} from "views/components/exist/exist.component";
import {FriendTitle} from "views/components/friend_title/friend_title.component";
import styled from "@emotion/styled";
import {observer} from "mobx-react";
import botImage from "assets/img/bot_image.png";

const LevelWrapper = styled.div<{size: number}>`
	display: flex;
	flex-flow: column;
	justify-content: center;
	align-items: center;

	img {
		width: ${(props) => props.size}px;
		height: ${(props) => props.size}px;
	}
	&.friend {
		transform: translateY(2px);
	}
`;

const PositionFriendTitle = styled.div`
	transform: translateY(-4px);
`;

interface IProps {
	level?: GameLevel | null;
	isFriend?: boolean;
	isBot?: boolean;
	size?: number;
}

export const H2hLevelBadge: React.FC<IProps> = observer(({level, isFriend, isBot, size = 32}) => {
	return (
		<LevelWrapper className={isFriend ? "friend" : ""} size={size}>
			<Exist when={isBot}>
				<img src={botImage} alt="" />
			</Exist>
			<Exist when={!isBot}>
				<LevelBadge level={level || GameLevel.SINGLE_A} size={size} />
			</Exist>
			<Exist when={isFriend}>
				<PositionFriendTitle>
					<FriendTitle isPending={false} />
				</PositionFriendTitle>
			</Exist>
		</LevelWrapper>
	);
});
